import setCompareItems from './set-compare-items.js';
import getCompareItems from './get-compare-items.js';
import findCompareItemFromList from './find-compare-item-from-list.js';

/** @typedef {import('./typedefs.js').CompareItem} CompareItem */

/**
 * Cancel compare of given items
 *
 * @param {CompareItem[]} cancelItems
 */
export default function cancelCompare(...cancelItems) {
  const { items } = getCompareItems();
  setCompareItems({
    items: items.filter(({ prid, catalog }) => !findCompareItemFromList(cancelItems, prid, catalog))
  });
}
